import React, { PureComponent } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Heading, media, Text } from "../../../components/styled";
import {
  helpTextLocalization,
  number,
  projectsLocalization,
  commonLocalization,
  currency,
} from "../../../localization";
import { Projects } from "../../visualization";
import PieChart from "../../visualization/pieChart/pieChart";
import { images } from "../../../config/index";
import EvaluationScoreChart from "../../../components/layouts/evaluationScoreChart";

const colors = ["#408a4b", "#0e5d9e", "#3B4155", "#c54357", "#3AA84B"];

class ProjectStatusChart extends PureComponent {
  getProjectsStats = (stats) => {
    const newData = {};
    const { status, total } = stats.overall;

    newData["total_projects"] = total.count;
    Object.keys(status).forEach((val, index) => {
      newData[val] = status[val].count;
    });

    return newData;
  };

  getPieData(d) {
    let data = JSON.parse(JSON.stringify(d));

    // Check for old format
    if (
      Object.values(data).every(
        (val) => typeof val === "object" && val !== null && "count" in val
      )
    ) {
      Object.keys(data).forEach((key) => {
        data[key] = data[key].count;
      });
      return data;
    }

    // Check for new local-projects format
    if (Object.values(data).every((val) => typeof val === "number")) {
      return {
        Submitted: data.submitted_projects || 0,
        Evaluated: data.evaluated_projects || 0,
      };
    }

    return {};
  }

  projectStatusTitle() {
    const { selectedLanguage } = this.props;
    const wardValue = number(this.props.wardValue);

    const { projectStatus } = projectsLocalization[selectedLanguage];

    if (wardValue === "All") {
      return <Text.span>{projectStatus}</Text.span>;
    }

    if (selectedLanguage === "en") {
      return (
        <Text.span>
          {projectStatus} for <strong>ward {wardValue}</strong>
        </Text.span>
      );
    }
    return (
      <Text.span>
        <strong>वडा {wardValue}</strong> का लागि {projectStatus}
      </Text.span>
    );
  }

  render() {
    const { selectedLanguage, stats, navigateToProject, selectedProjectType } =
      this.props;

    const { projectStatus: projectStatusHelpText } =
      helpTextLocalization[selectedLanguage];

    const localization = commonLocalization[selectedLanguage];

    return (
      <ChartsBlock className='charts-block' lang={selectedLanguage}>
        <Heading.h2
          uppercase
          style={{ marginBottom: 0 }}
          className='flex items-center'
        >
          <Text.span className='help-text'>
            <Text.span className='help-text__icon'>
              <img
                className='help-icon'
                height={18}
                width={18}
                src={images.icons.help}
                alt='help'
              />
            </Text.span>
            <Text.span className='help-text__content tooltip'>
              <Text.span className='tooltip-arrow'>arrow</Text.span>
              {projectStatusHelpText}
            </Text.span>
          </Text.span>
          {this.projectStatusTitle()}
        </Heading.h2>
        <PieChartMain className='evaluated-chart'>
          <StatsWrapper>
            <Projects
              data={
                selectedProjectType === "local-projects"
                  ? stats
                  : stats.status_wise
              }
              colors={colors}
              navigateToProject={navigateToProject}
              selectedProjectType={selectedProjectType}
            />
          </StatsWrapper>

          {stats && (
            <div className='pie-wrapper'>
              <PieChart
                data={
                  selectedProjectType === "local-projects"
                    ? this.getPieData(stats)
                    : this.getPieData(stats.status_wise)
                }
                radius={100}
                hole={0}
                colors={colors}
                labels
                percent
                strokeWidth={0}
                stroke='#fff'
              />
            </div>
          )}

          <div className='flex flex-col gap-1 mt-10'>
            <strong className='text-base'>
              {stats && currency(stats && stats.budget_sum)}
            </strong>
            <span className='uppercase opacity-70'>
              {localization.expectedBudget}
            </span>
          </div>
        </PieChartMain>
      </ChartsBlock>
    );
  }
}

const StatsWrapper = styled.div`
  /* width: 240px; */
  margin-bottom: 14px;
  ${media.tabletSmall`margin:0`};
  .stats-label {
    display: none;
  }
  .projects-block:first-child {
    padding: 0;
  }
  .projects-value {
    font-size: 30px;
  }
`;

const PieChartMain = styled.div`
  @media all and (min-width: 500px) and (max-width: 991px),
    (min-width: 1200px) {
    align-items: flex-end;
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
    /* > div:first-child {
      margin-right: 20px;
    } */
    /* justify-content: space-between; */
  }
  .projects-block {
    margin-bottom: 12px;
    padding-left: 10px;
    width: 50% !important;
    /* width: 40%; */
    &:first-child {
      margin-top: 4px;
    }
    ${media.tabletWide`&:nth-child(2n+1) {padding: 0;}`};
  }
  .projects-value:before {
    display: block;
  }
  .pie-wrapper {
    margin-top: 36px;
    width: 100%;
  }
`;

const ChartsBlock = styled.div`
  // padding: 24px;
  // padding: 64px 0 30px;

  h2 {
    font-size: ${(props) => (props.lang === "en" ? "12px" : "14px")};
    > span:last-child {
      font-size: ${(props) => (props.lang === "en" ? "12px" : "14px")};
      opacity: 0.7;
    }
  }
  .help-text__content {
    font-size: ${(props) => (props.lang === "en" ? "11px" : "13px")};
  }
`;

export default connect((state) => ({
  selectedLanguage: state.localizationReducers.selectedLanguage,
}))(ProjectStatusChart);



// WEBPACK FOOTER //
// ./src/components/layouts/projectStatusChart/projectStatusChart.js